import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  background-color: #fff; /* White background color */
  color: #333; /* Text color */
  padding: 20px; /* Padding around content */
  position: fixed; /* Fixed positioning */
  top: 0; /* Align to the top of the viewport */
  width: 100%; /* Take full width of the viewport */
  z-index: 999; /* Ensure the header appears on top of other content */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Small shadow below */
  display: flex; /* Use flexbox for layout */
  justify-content: space-between; /* Space items evenly */
  align-items: center; /* Center items vertically */
  /* margin-bottom: 20px; */
`;

export const Logo = styled.img`
 height: 50px; /* Set the height of the logo */
 width: auto;
 /* border: 1px solid red; */
 margin-left: 7%;
`;

export const Menu = styled.ul`
  list-style-type: none; /* Remove bullet points from list */
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  margin-right: 7%;
`;

export const MenuItem = styled.li`
  display: inline-block; /* Display items horizontally */
  margin-right: 20px; /* Spacing between items */
`;

export const MenuLink = styled.a`
  color: #333; /* Link color */
  text-decoration: none; /* Remove underline */
  font-weight: bold;
  color: #1D2C42; /* Link color */
  
  &:hover {
    border-bottom: 1px solid #333; /* Add solid border on hover */
  }
  text-decoration: none; /* Remove underline */
  /* color: inherit; Inherit color from parent */
  
  &:visited {
    color: #1D2C42; /* Inherit color from parent */
  }
`;